import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "sidebar-header"
};
const _hoisted_2 = {
  key: 0,
  class: "sidebar-logo"
};
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
  key: 1,
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const _hoisted_5 = {
  class: "logo-copy"
};
const _hoisted_6 = {
  class: "logo-text"
};
const _hoisted_7 = ["title"];
const _hoisted_8 = {
  class: "sidebar-search"
};
const _hoisted_9 = {
  class: "sidebar-section"
};
const _hoisted_10 = {
  class: "badge"
};
const _hoisted_11 = ["src", "alt"];
const _hoisted_12 = {
  key: 1,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const _hoisted_13 = {
  class: "submenu-text"
};
const _hoisted_14 = {
  class: "submenu-count"
};
const _hoisted_15 = {
  class: "badge"
};
const _hoisted_16 = ["src", "alt"];
const _hoisted_17 = {
  key: 1,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const _hoisted_18 = {
  class: "submenu-text"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["src", "alt"];
const _hoisted_21 = {
  key: 1,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const _hoisted_22 = {
  class: "submenu-text"
};
const _hoisted_23 = {
  key: 0,
  class: "live-indicator"
};
const _hoisted_24 = {
  class: "live-text"
};
const _hoisted_25 = {
  key: 0,
  class: "live-count"
};
const _hoisted_26 = {
  class: "sidebar-section"
};
const _hoisted_27 = {
  key: 1,
  class: "sidebar-footer"
};
const _hoisted_28 = {
  class: "sidebar-user"
};
const _hoisted_29 = {
  class: "avatar"
};
const _hoisted_30 = ["src", "alt"];
const _hoisted_31 = {
  key: 1
};
const _hoisted_32 = {
  class: "user-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _directive_b_tooltip = _resolveDirective("b-tooltip");
  return $data.networkInfo ? (_openBlock(), _createElementBlock("aside", {
    key: 0,
    class: _normalizeClass(["sidebar", {
      collapsed: $props.collapsed
    }]),
    role: "region",
    "aria-label": "sidebar"
  }, [_createElementVNode("div", _hoisted_1, [!$props.collapsed ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
    class: _normalizeClass(["logo-icon", {
      'has-image': !!$options.sidebarLogo
    }])
  }, [$options.sidebarLogo ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $options.sidebarLogo,
    alt: $data.networkInfo.name
  }, null, 8, _hoisted_3)) : (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[7] || (_cache[7] = [_createElementVNode("polygon", {
    points: "23 7 16 12 23 17 23 7"
  }, null, -1), _createElementVNode("rect", {
    x: "1",
    y: "5",
    width: "15",
    height: "14",
    rx: "2",
    ry: "2"
  }, null, -1)]))]))], 2), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString($data.networkInfo.name), 1), _cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "logo-sub"
  }, "An SBN Powered Network", -1))])])) : _createCommentVNode("", true), _createElementVNode("button", {
    class: "sidebar-toggle-btn",
    type: "button",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('toggle-collapse')),
    title: $props.collapsed ? 'Expand sidebar' : 'Collapse sidebar'
  }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
    viewBox: "0 0 24 24"
  }, [_createElementVNode("polyline", {
    points: "15 18 9 12 15 6"
  })], -1)]))], 8, _hoisted_7)]), !$props.collapsed ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("form", {
    class: "search-wrapper",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers((...args) => $options.submitSidebarSearch && $options.submitSidebarSearch(...args), ["prevent"]))
  }, [_cache[10] || (_cache[10] = _createStaticVNode("<button type=\"submit\" class=\"search-icon-btn\" title=\"Search network\" data-v-2ff482c6><span class=\"search-icon\" data-v-2ff482c6><svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2ff482c6><circle cx=\"11\" cy=\"11\" r=\"8\" data-v-2ff482c6></circle><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\" data-v-2ff482c6></line></svg></span></button>", 1)), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.search = $event),
    type: "text",
    placeholder: "Search Network",
    onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers((...args) => $options.submitSidebarSearch && $options.submitSidebarSearch(...args), ["prevent"]), ["enter"]))
  }, null, 544), [[_vModelText, $data.search]])], 32)]), _createElementVNode("div", _hoisted_9, [_cache[20] || (_cache[20] = _createElementVNode("div", {
    class: "sidebar-section-label"
  }, "Navigate", -1)), _createElementVNode("button", {
    class: _normalizeClass(["sidebar-link sidebar-link-button", {
      active: $options.isChannelsActive,
      expanded: $data.channelsExpanded
    }]),
    type: "button",
    onClick: _cache[4] || (_cache[4] = $event => $data.channelsExpanded = !$data.channelsExpanded)
  }, [_cache[11] || (_cache[11] = _createStaticVNode("<span class=\"link-icon\" data-v-2ff482c6><svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2ff482c6><rect x=\"2\" y=\"3\" width=\"20\" height=\"14\" rx=\"2\" data-v-2ff482c6></rect><line x1=\"8\" y1=\"21\" x2=\"16\" y2=\"21\" data-v-2ff482c6></line><line x1=\"12\" y1=\"17\" x2=\"12\" y2=\"21\" data-v-2ff482c6></line></svg></span><span class=\"link-text\" data-v-2ff482c6>Channels</span>", 2)), _createElementVNode("span", _hoisted_10, _toDisplayString($options.filteredChannels.length), 1), _cache[12] || (_cache[12] = _createElementVNode("span", {
    class: "chevron"
  }, [_createElementVNode("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [_createElementVNode("polyline", {
    points: "9 18 15 12 9 6"
  })])], -1))], 2), _createElementVNode("div", {
    class: _normalizeClass(["channel-submenu", {
      open: $data.channelsExpanded
    }])
  }, [_createVNode(_component_router_link, {
    class: _normalizeClass(["submenu-link", {
      active: +$data.channel_id === 0 && $data.channel_id != null
    }]),
    to: "/video/channel"
  }, {
    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createElementVNode("span", {
      class: "submenu-thumb all-thumb"
    }, [_createElementVNode("svg", {
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [_createElementVNode("rect", {
      x: "2",
      y: "3",
      width: "20",
      height: "14",
      rx: "2"
    }), _createElementVNode("line", {
      x1: "8",
      y1: "21",
      x2: "16",
      y2: "21"
    }), _createElementVNode("line", {
      x1: "12",
      y1: "17",
      x2: "12",
      y2: "21"
    })])], -1), _createElementVNode("span", {
      class: "submenu-text"
    }, "All Channels", -1)]))], undefined, true),
    _: 1
  }, 8, ["class"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredChannels, c => {
    return _withDirectives((_openBlock(), _createBlock(_component_router_link, {
      key: c.id,
      class: _normalizeClass(["submenu-link", {
        active: +$data.channel_id === +c.id
      }]),
      to: '/video/channel/' + c.id + '/',
      title: c.description ? c.description : ''
    }, {
      default: _withCtx(() => [_createElementVNode("span", {
        class: _normalizeClass(["submenu-thumb", {
          'has-image': !!$options.getChannelLogo(c)
        }])
      }, [$options.getChannelLogo(c) ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: $options.getChannelLogo(c),
        alt: c.name
      }, null, 8, _hoisted_11)) : (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[14] || (_cache[14] = [_createElementVNode("rect", {
        x: "2",
        y: "3",
        width: "20",
        height: "14",
        rx: "2"
      }, null, -1), _createElementVNode("line", {
        x1: "8",
        y1: "21",
        x2: "16",
        y2: "21"
      }, null, -1), _createElementVNode("line", {
        x1: "12",
        y1: "17",
        x2: "12",
        y2: "21"
      }, null, -1)]))]))], 2), _createElementVNode("span", _hoisted_13, _toDisplayString(c.name), 1), _createElementVNode("span", _hoisted_14, _toDisplayString(c.publishedvideocount ? c.publishedvideocount : c.videocount), 1)], undefined, true),
      _: 2
    }, 1032, ["class", "to", "title"])), [[_directive_b_tooltip, void 0, void 0, {
      hover: true
    }]]);
  }), 128))], 2), _createVNode(_component_router_link, {
    to: "/live-now",
    class: _normalizeClass(["sidebar-link", {
      active: _ctx.$route.path === '/live-now'
    }])
  }, {
    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createElementVNode("span", {
      class: "link-icon"
    }, [_createElementVNode("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [_createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), _createElementVNode("polygon", {
      points: "10 8 16 12 10 16 10 8"
    })])], -1), _createElementVNode("span", {
      class: "link-text"
    }, "Live Now", -1)]))], undefined, true),
    _: 1
  }, 8, ["class"]), $data.user && $data.user.networks && $data.user.networks.length > 0 ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: _normalizeClass(["sidebar-link sidebar-link-button", {
      expanded: $data.networksExpanded
    }]),
    type: "button",
    onClick: _cache[5] || (_cache[5] = $event => $data.networksExpanded = !$data.networksExpanded)
  }, [_cache[16] || (_cache[16] = _createStaticVNode("<span class=\"link-icon\" data-v-2ff482c6><svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2ff482c6><path d=\"M4 11a9 9 0 0 1 9 9\" data-v-2ff482c6></path><path d=\"M4 4a16 16 0 0 1 16 16\" data-v-2ff482c6></path><circle cx=\"5\" cy=\"19\" r=\"1\" data-v-2ff482c6></circle></svg></span><span class=\"link-text\" data-v-2ff482c6>My Networks</span>", 2)), _createElementVNode("span", _hoisted_15, _toDisplayString($options.filteredNetworks.length), 1), _cache[17] || (_cache[17] = _createElementVNode("span", {
    class: "chevron"
  }, [_createElementVNode("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [_createElementVNode("polyline", {
    points: "9 18 15 12 9 6"
  })])], -1))], 2)) : _createCommentVNode("", true), $data.user && $data.user.networks && $data.user.networks.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["channel-submenu", {
      open: $data.networksExpanded
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredNetworks, net => {
    return _openBlock(), _createElementBlock("div", {
      key: net.id
    }, [+net.id === +$data.networkInfo.id ? (_openBlock(), _createBlock(_component_router_link, {
      key: 0,
      class: "submenu-link active",
      to: "/video/channel"
    }, {
      default: _withCtx(() => [_createElementVNode("span", {
        class: _normalizeClass(["submenu-thumb", {
          'has-image': !!$options.getNetworkLogo(net)
        }])
      }, [$options.getNetworkLogo(net) ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: $options.getNetworkLogo(net),
        alt: net.name
      }, null, 8, _hoisted_16)) : (_openBlock(), _createElementBlock("svg", _hoisted_17, [...(_cache[18] || (_cache[18] = [_createElementVNode("polygon", {
        points: "23 7 16 12 23 17 23 7"
      }, null, -1), _createElementVNode("rect", {
        x: "1",
        y: "5",
        width: "15",
        height: "14",
        rx: "2",
        ry: "2"
      }, null, -1)]))]))], 2), _createElementVNode("span", _hoisted_18, _toDisplayString(net.name), 1)], undefined, true),
      _: 2
    }, 1024)) : (_openBlock(), _createElementBlock("a", {
      key: 1,
      href: "javascript:void(0)",
      class: "submenu-link",
      onClick: $event => $options.swapnetwork(net)
    }, [_createElementVNode("span", {
      class: _normalizeClass(["submenu-thumb", {
        'has-image': !!$options.getNetworkLogo(net)
      }])
    }, [$options.getNetworkLogo(net) ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: $options.getNetworkLogo(net),
      alt: net.name
    }, null, 8, _hoisted_20)) : (_openBlock(), _createElementBlock("svg", _hoisted_21, [...(_cache[19] || (_cache[19] = [_createElementVNode("polygon", {
      points: "23 7 16 12 23 17 23 7"
    }, null, -1), _createElementVNode("rect", {
      x: "1",
      y: "5",
      width: "15",
      height: "14",
      rx: "2",
      ry: "2"
    }, null, -1)]))]))], 2), _createElementVNode("span", _hoisted_22, _toDisplayString(net.name), 1)], 8, _hoisted_19))]);
  }), 128))], 2)) : _createCommentVNode("", true)]), $options.liveSummary.count > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_cache[21] || (_cache[21] = _createElementVNode("div", {
    class: "live-dot live-dot-red"
  }, null, -1)), _createElementVNode("span", _hoisted_24, _toDisplayString($options.liveSummary.count) + " Live Now", 1), $options.liveSummary.label ? (_openBlock(), _createElementBlock("span", _hoisted_25, "— " + _toDisplayString($options.liveSummary.label), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _cache[28] || (_cache[28] = _createElementVNode("div", {
    class: "sidebar-divider"
  }, null, -1)), _createElementVNode("div", _hoisted_26, [_cache[26] || (_cache[26] = _createElementVNode("div", {
    class: "sidebar-section-label"
  }, "Account", -1)), _createVNode(_component_router_link, {
    to: "/account/",
    class: "sidebar-link"
  }, {
    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createElementVNode("span", {
      class: "link-icon"
    }, [_createElementVNode("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [_createElementVNode("path", {
      d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
    }), _createElementVNode("circle", {
      cx: "12",
      cy: "7",
      r: "4"
    })])], -1), _createElementVNode("span", {
      class: "link-text"
    }, "My Profile", -1)]))], undefined, true),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/account/subscription/",
    class: "sidebar-link"
  }, {
    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createElementVNode("span", {
      class: "link-icon"
    }, [_createElementVNode("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [_createElementVNode("path", {
      d: "M21 12V7H5a2 2 0 0 1 0-4h14v4"
    }), _createElementVNode("path", {
      d: "M3 5v14a2 2 0 0 0 2 2h16v-5"
    }), _createElementVNode("path", {
      d: "M18 12a2 2 0 0 0 0 4h4v-4Z"
    })])], -1), _createElementVNode("span", {
      class: "link-text"
    }, "My Subscription", -1)]))], undefined, true),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/account/billing/",
    class: "sidebar-link"
  }, {
    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createElementVNode("span", {
      class: "link-icon"
    }, [_createElementVNode("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [_createElementVNode("rect", {
      x: "1",
      y: "4",
      width: "22",
      height: "16",
      rx: "2",
      ry: "2"
    }), _createElementVNode("line", {
      x1: "1",
      y1: "10",
      x2: "23",
      y2: "10"
    })])], -1), _createElementVNode("span", {
      class: "link-text"
    }, "My Credit Cards", -1)]))], undefined, true),
    _: 1
  }), _createElementVNode("a", {
    href: "javascript:void(0)",
    class: "sidebar-link",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.logout && $options.logout(...args))
  }, [...(_cache[25] || (_cache[25] = [_createStaticVNode("<span class=\"link-icon\" data-v-2ff482c6><svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2ff482c6><path d=\"M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4\" data-v-2ff482c6></path><polyline points=\"16 17 21 12 16 7\" data-v-2ff482c6></polyline><line x1=\"21\" y1=\"12\" x2=\"9\" y2=\"12\" data-v-2ff482c6></line></svg></span><span class=\"link-text\" data-v-2ff482c6>Sign Out</span>", 2)]))])]), $data.user ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [$data.user.profileimage_display ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.user.profileimage_display,
    alt: $data.user.firstname || $data.user.name || 'User'
  }, null, 8, _hoisted_30)) : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString($options.userInitials), 1))]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_32, _toDisplayString($options.userDisplayName), 1), _cache[27] || (_cache[27] = _createElementVNode("div", {
    class: "user-role"
  }, "Viewer", -1))])])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true);
}